import React, { CSSProperties, MouseEventHandler } from 'react';
import { PageData } from '../../../../../interfaces/interfaces';
import { StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { createDisplayLink } from '../../../../../services/helper';
import VyReactPlayer from '../../../../common/VyReactPlayer';
const VystemStudio = ({
  stageSettings,
  uiComponent,
  playerStyle,
  currentTime,
  isPlaying,
  onClickResize,
}: {
  stageSettings: PageData['stageSettings'];
  uiComponent?: StageComponentInterface;
  playerStyle?: CSSProperties;
  onClickResize?: MouseEventHandler<HTMLDivElement>;
  currentTime?: number;
  isPlaying?: boolean;
}) => {
  // deprecated
  //@ts-ignore
  if (stageSettings?.vystemStudio?.liveStream?.hls) {
    return (
      <VyReactPlayer
        props={{
          style: playerStyle ?? { backgroundColor: 'black', width: '100%', maxWidth: '100% !important' },
          width: '100%',
          height: '100%',
          controls: true,
          light: stageSettings?.vystemStudio?.thumbnail ? createDisplayLink(stageSettings.vystemStudio.thumbnail) : undefined,
          // deprecated
          //@ts-ignore
          url: stageSettings?.vystemStudio?.liveStream?.hls,
          playing: isPlaying ?? false,
        }}
        wrapperProps={{ onclick: onClickResize }}
        stageSettings={stageSettings}
        uiComponent={uiComponent}
        currentTime={currentTime}
      />
    );
  }

  return <></>;
};

export default VystemStudio;
